import { FunctionComponent, useEffect } from 'react'
import { Params } from '../../redux/selectors/initRouterParamsSelector'
import { ROUTE_OVERVIEW } from '../../constants/routes'
import NavTarget from '../../entities/NavTarget'
import { push } from 'connected-react-router'
import { useDispatch } from 'react-redux'
import { setShouldNavigateToTarget } from '../../redux/actions/app/navigation.actions'
import NavLink from '../../entities/NavLink'

export type Props = {
    shouldNavigateToTarget: boolean
    requestsArePending: boolean
    navigationTargets: NavTarget[]
    routerParams: Params
    availableNavLinks: NavLink[]
}

const TargetNavigation: FunctionComponent<Props> = (props) => {
    const { shouldNavigateToTarget, requestsArePending, navigationTargets, routerParams, availableNavLinks} = props
    const dispatch = useDispatch()

    useEffect(() => {

        if (shouldNavigateToTarget && !requestsArePending) {

            const targetFromRouter = routerParams?.target

            let targetToNavigateTo = ROUTE_OVERVIEW
            if (navigationTargets && targetFromRouter) {
                const navTarget = navigationTargets.find((target: NavTarget) => target.id === targetFromRouter)
                const navLink = availableNavLinks.find(link => link.id === navTarget?.value || link.url === `/${navTarget?.value}`)
                if (navLink) {
                    targetToNavigateTo = navLink.url
                } else {
                    // Handle special cases if no matching navLink is found
                    if (navTarget) {
                        if (navTarget.id === "colors") {
                            const exteriorTarget = navigationTargets.find(target => target.id === 'exterior')
                            const exteriorLink = availableNavLinks.find(link => link.id === exteriorTarget?.value || link.url === `/${exteriorTarget?.value}`)
                            targetToNavigateTo = exteriorLink?.url || targetToNavigateTo
                        } else if (navTarget.id === "exterior" || navTarget.id === "interior") {
                            const colorsTarget = navigationTargets.find(target => target.id === 'colors')
                            const colorsLink = availableNavLinks.find(link => link.id === colorsTarget?.value || link.url === `/${colorsTarget?.value}`)
                            targetToNavigateTo = colorsLink?.url || targetToNavigateTo
                        }
                    }
                }
            }
            dispatch(setShouldNavigateToTarget(false))
            dispatch(push(targetToNavigateTo))
        }

    }, [dispatch, requestsArePending, navigationTargets, routerParams?.target, shouldNavigateToTarget, availableNavLinks])

    return null
}

export default TargetNavigation
